import React from "react";

export default function Multilangual() {
  return (
    <div className="bg-lingual bg-cover bg-no-repeat bg-center flex items-center  justify-center">
      <div className="mainDiv md:w-6/12 w-11/12 flex-col items-center  justify-center text-white py-36">
        <h2 className="text-4xl font-bold font-secondary">
          <span className="text-orange">Multilingual</span> Support Enabled by Our Specialist Website
          Translators
        </h2>
        <p className="pt-10 font-light leading-loose font-opensans">
          Our website translation service is done by website translators expert
          in two or more languages, from our selection of over 120 languages
          with 950+ language pairs. They're also industry experts that have
          insights on whichever industry your website belongs to, be it
          cryptocurrency or ecommerce. Tomedes prides itself on the skill of our
          multilingual, multi-industry experts. Get started now.
        </p>
      </div>
    </div>
  );
}
